// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","fadeInOpacity":"Loader_fadeInOpacity__bvILc","loader__fullScreen":"Loader_loader__fullScreen__5mVgt"};